interface GetKpiAmountInput {
    kpis: ProKpis;
    kpiType: keyof ProKpis | 'earnings_misc_bulk';
}

export const getKpiAmount = ({ kpis, kpiType }: GetKpiAmountInput): number => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- 'earnings_misc_bulk' is not present the AppSync schema, but I'm pretty sure we need to support it.
    // @ts-ignore
    let amount = kpis?.[kpiType] ?? 0;

    if (typeof amount === 'string') {
        try {
            amount = parseInt(amount, 10);
        } catch {
            amount = 0;
        }
    }

    return amount;
};
